export class UserRights {

    public static AdminBo = "0EB693A6-839C-4217-A741-68EE77854695";
    public static UserFo = "CA0FAA65-6258-4DE6-A548-AD10B3EEE4CA";
}
